import React from 'react'
import { IntroPage } from './IntroPage'
import { getIntroItem } from './IntroItem'
import useWindowSize from '../../utils/useWindowSize'
import { selectSheetSource } from '../../store/slices/sheetsSlice'
import { useAppSelector } from '../../store/hooks'

const IntroUserSpecificTransparency = ({
  goToPrivacyScreen,
  onClickConfirmButton,
}: {
  goToPrivacyScreen: () => void
  onClickConfirmButton: () => void
}) => {
  const sheetSource = useAppSelector(selectSheetSource)
  const { isSmallScreen } = useWindowSize()
  const introItem = getIntroItem(isSmallScreen, sheetSource)
  return (
    <IntroPage
      item={introItem}
      goToPrivacyScreen={goToPrivacyScreen}
      onClickConfirmButton={onClickConfirmButton}
    />
  )
}

export default IntroUserSpecificTransparency
